<template>
  <div>
    <v-flex xs12 pb-3>
      <v-text-field
        outline
        label="Name on card"
        placeholder="Name on card"
        v-model="cardname"
        single-line
        hide-details
        :disabled="disabled"
        @input="updateCredit"
      ></v-text-field>
    </v-flex>

    <v-flex xs12 pb-3>
      <v-text-field
        outline
        label="Card Number"
        placeholder="1111-1111-1111-1112"
        mask="credit-card"
        v-model="cardnumber"
        single-line
        hide-details
        :disabled="disabled"
        @input="updateCredit"
      ></v-text-field>
    </v-flex>

    <v-layout wrap>
      <v-flex xs6>
        <v-text-field
          outline
          label="Expiry Date"
          placeholder="Expiry Date"
          mask="##/##"
          v-model="expiryDate"
          single-line
          hide-details
          :disabled="disabled"
          @input="updateCredit"
        ></v-text-field>
      </v-flex>
      <v-flex offset-xs1 xs4>
        <v-text-field
          outline
          label="CVV"
          placeholder="CVV"
          mask="###"
          type="password"
          v-model="cvv"
          single-line
          hide-details
          :disabled="disabled"
          @input="updateCredit"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- <v-flex class="pb-2 body-1">
      <v-checkbox
        v-model="saved"
        :label="text.saveCard"
        hide-details
        @change="updateCredit"
      ></v-checkbox>
    </v-flex> -->
  </div>
</template>

<script>
export default {
  props: ['disabled'],

  data() {
    return {
      cardname: '',
      cardnumber: null,
      expiryDate: null,
      cvv: null,
      saved: false
    }
  },

  computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          saveCard: 'Remember this card'
        }
      } else {
        obj = {
          saveCard: 'บันทึกข้อมูลบัตรเพื่อใช้ในครั้งหน้า'
        }
      }
      return obj
    }
  },

  methods: {
    updateCredit() {
      let completed = {
        amount: 0,
        cardname: '',
        cardnumber: '',
        expmonth: '',
        expyear: '',
        cvv: '',
        savecard: false,
        complete: false
      }
      if (
        this.cardname &&
        this.cardnumber &&
        this.cardnumber.length == 16 &&
        this.expiryDate &&
        this.expiryDate.length == 4 &&
        this.cvv &&
        this.cvv.length == 3
      )
        completed = {
          amount: this.$store.state.amount,
          cardname: this.cardname,
          cardnumber: this.cardnumber,
          expmonth: this.expiryDate.slice(0, 2),
          expyear: '20' + this.expiryDate.slice(2, 4),
          cvv: this.cvv,
          savecard: this.saved,
          complete: true
        }
      this.$emit('input', completed)
    }
  }
}
</script>

<style scoped>
input.style-1 {
  padding: 12px;
  border: 2px solid rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  font-size: 16px;
}
input.style-1::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: rgba(0, 0, 0, 0.37);
  opacity: 1; /* Firefox */
}

input.style-1:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(0, 0, 0, 0.37);
}

input.style-1::-ms-input-placeholder {
  /* Microsoft Edge */
  color: rgba(0, 0, 0, 0.37);
}
</style>
